import type { ErrorBoundaryState } from './types'

export const ERROR_BOUNDARY_INITIAL_STATE: ErrorBoundaryState = {
  hasError: false,
  error: null,
}
